import styled from 'styled-components';
import { MediaQueries } from '~/constants/constVars';
import { theme } from './themes';

export const MainOnboardingContainer = styled.div<{
  background?: React.CSSProperties['background'];
}>`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.document};
  min-height: var(--client-height);
  background: ${(props) => props.background ?? theme.colors.neutral12};
  font-size: 16px;
  @media ${MediaQueries.smallScreenPortrait} {
    width: 100%;
    background: ${(props) => props.background ?? theme.colors.white};
  }
`;

export const OnboardingStepsContainer = styled.div<{
  justify?: React.CSSProperties['justifyContent'];
}>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justify ?? 'flex-start'};
  align-items: center;
  align-self: center;
  padding: 0 2em;
  width: 100%;
  @media (orientation: landscape) {
    max-width: 40em;
  }

  height: calc(
    var(--client-height) - (var(--onboarding-navbar-height) * 2)
  ); // total screen height - 2x navbar height
  @media ${MediaQueries.mediumScreen} {
    height: calc(
      var(--client-height) - (var(--onboarding-navbar-height) * 3)
    ); // total screen height - 3x navbar height
  }
  @media ${MediaQueries.smallScreenPortrait} {
    padding: 0;
    background-color: ${theme.colors.white};
  }
`;

export const SubmissionIdentificationExplanation = styled.div`
  margin-bottom: 2em;
  text-align: center;
`;
